module.exports = __webpack_public_path__ + "static/flexi_desks_1-7bb22452ba8743e530858409f0eb9a66.jpg";